// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Additional custom styles */
.event-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.event-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.sport-card {
  transition: all 0.3s ease;
}

.sport-card:hover {
  transform: scale(1.05);
}

.sport-card.selected {
  ring: 4px;
  ring-color: #f97316;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB","sourcesContent":["/* Additional custom styles */\n.event-card {\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.event-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n}\n\n.sport-card {\n  transition: all 0.3s ease;\n}\n\n.sport-card:hover {\n  transform: scale(1.05);\n}\n\n.sport-card.selected {\n  ring: 4px;\n  ring-color: #f97316;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
